import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_VENDOR_DASHBOARD, GET_VENDOR_DASHBOARD_SUCCESS, GET_VENDOR_DASHBOARD_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';

function* getVendorDashboard({ payload }) {
  try {
    // Sibling /v2/vendor/* endpoints (car-type, car-regions, chauffeur) all strip this header —
    // it isn't in this backend route's CORS allow-list, so leaving it in blocks the request/cookies.
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/dashboard`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_DASHBOARD_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VENDOR_DASHBOARD_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_DASHBOARD_ERROR, payload: error });
  }
}

export function* watchGetVendorDashboard() {
  yield takeEvery(GET_VENDOR_DASHBOARD, getVendorDashboard);
}

function* getVendorDashboardSaga() {
  yield all([fork(watchGetVendorDashboard)]);
}

export default getVendorDashboardSaga;
